import z from 'zod'
import { E164PhoneSchema } from '../../../../../../@core/@shared/infra/schemas/E164Phone.schema'
import { NotificationChannelEnum } from '../../../../../../@core/fire-risk-settings/domain/enums/NotificationChannel.enum'

export const NotifiedUserFormSchema = z.object({
	name: z.string().min(1),
	email: z.email().nonempty(),
	phoneNumber: E164PhoneSchema,
	channels: z.array(z.enum(NotificationChannelEnum)).nonempty(),
	farms: z.array(z.uuid()).nonempty(),
})
